import { combineReducers } from 'redux'
import { ignoreActions } from 'redux-ignore'
import {
  SHORTLIST_UPDATE,
  TRACK_PLAY_PROGRESS_UPDATE,
  USER_LOGOUT,
} from '@disco/constants/ActionTypes'
import { initialState as initialAppState } from './app'
import type { State } from './index'
import { reducers } from './index'
import { routerHistoryReducer } from './router'
import { userBusinessesApi } from '../ducks/businesses'
import { api } from '../api/index'
const { ...optimizedReducers } = reducers
// we allow processing of heavy actions that can affect performance of the app
// only in reducers where they are actually handled
const heavyActionsInclusionMap = {
  [SHORTLIST_UPDATE]: ['selection', 'shortlists'],
  [TRACK_PLAY_PROGRESS_UPDATE]: ['media'],
}

for (const reducer in optimizedReducers) {
  if (optimizedReducers[reducer]) {
    const actions = Object.keys(heavyActionsInclusionMap)
    const actionsToIgnore = actions.filter(
      action => !heavyActionsInclusionMap[action].includes(reducer),
    )
    optimizedReducers[reducer] = ignoreActions(
      optimizedReducers[reducer],
      actionsToIgnore,
    )
  }
}

const appReducer = combineReducers({
  ...optimizedReducers,
  media: reducers.media,
  routing: routerHistoryReducer,
  [userBusinessesApi.reducerPath]: userBusinessesApi.reducer,
  [api.reducerPath]: api.reducer,
})
export type AppState = State

export const rootReducer: (state: State, action: any) => State = (
  state,
  action,
) => {
  if (action.type === USER_LOGOUT)
    return appReducer(
      {
        app: { ...initialAppState, screen: state.app.screen }, // preserve screen state on logout
      },
      action,
    )
  return appReducer(state, action)
}
